<template>
  <div class="h-full">
    <iframe
      class="w-full h-full"
      :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/dataset/index?token=Bearer ${token}`"
      frameborder="0"
    ></iframe>
    <!-- 开发环境 http://localhost:9528/#/dataset/index -->
    <!-- 测试环境 :src="`${currentEnv.VUE_APP_DATASEASE_PAGE}/#/dataset/index`" -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      token: Wiz.AuthHooks.GetToken(),
    }
  },
}
</script>
